.phaseRail {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.phaseCard {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.6rem;
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  min-height: 16rem;
}

.phaseCard[data-phase="phase1"] {
  background: linear-gradient(165deg, var(--color-surface) 40%, color-mix(in srgb, var(--c-aqua) 12%, white));
  border-color: color-mix(in srgb, var(--c-aqua) 35%, var(--color-border));
}

.phaseLabel {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-accent);
}

.phaseCard h3 {
  font-family: var(--font-display);
  font-size: clamp(1.35rem, 2.4vw, 1.75rem);
  line-height: 1.2;
}

.phaseCard p {
  color: var(--color-text-muted);
  line-height: 1.6;
  flex: 1;
}

.phaseWindow {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--color-primary-strong);
}

.objectiveGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.objective {
  padding: 1.4rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.objective h3 {
  font-family: var(--font-sans);
  font-size: 1.05rem;
  font-weight: 600;
}

.objective p {
  color: var(--color-text-muted);
  line-height: 1.55;
  font-size: 0.95rem;
}

.number {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--color-accent);
}

.workflow {
  margin-top: 1.25rem;
  padding: 1rem 1.25rem;
  border-radius: var(--radius-md);
  background: var(--color-document);
  border: 1px solid var(--color-border);
  font-family: var(--font-mono);
  font-size: 0.86rem;
  line-height: 1.65;
  color: var(--color-text-muted);
}

.systemGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: 1rem;
}

.systemCard {
  padding: 1.35rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-surface);
}

.systemCard h3 {
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.systemCard p {
  color: var(--color-text-muted);
  line-height: 1.55;
  font-size: 0.95rem;
}

.outList {
  margin: 1rem 0 0;
  padding-left: 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  color: var(--color-text-muted);
  line-height: 1.5;
}

.principles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.principle {
  min-height: 14rem;
  padding: 1.4rem;
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.75rem;
}

.principle:nth-child(2) {
  margin-top: 1.5rem;
  background: var(--color-field-paper);
}

.principle h3 {
  font-family: var(--font-display);
  font-size: clamp(1.35rem, 2.2vw, 1.85rem);
}

.principle p {
  color: var(--color-text-muted);
  line-height: 1.55;
}

.disclaimer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 1.5rem;
  align-items: center;
  padding: clamp(1.5rem, 4vw, 2.4rem);
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  background: var(--color-document);
}

.disclaimer p {
  margin-top: 0.75rem;
  max-width: 52rem;
  color: var(--color-text-muted);
  line-height: 1.65;
}

.ctaButtons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  justify-content: flex-end;
}

@media (max-width: 980px) {
  .phaseRail,
  .objectiveGrid,
  .principles {
    grid-template-columns: 1fr;
  }

  .principle:nth-child(2) {
    margin-top: 0;
  }

  .disclaimer {
    grid-template-columns: 1fr;
  }

  .ctaButtons {
    justify-content: flex-start;
  }
}
